import { Lightning } from '@lightningjs/sdk'

export default class NowPlaying extends Lightning.Component {
  static _template() {
    return {
      Header: {
        x: 0,
        y: 0,
        text: {
          text: 'NOW PLAYING',
          fontStyle: 'bold',
          textColor: 0xffffffff,
          fontSize: 34,
        },
      },
      Title: {
        x: 0,
        y: 50,
        text: {
          text: 'Loading...',
          textColor: 0xffffffff,
          fontSize: 34,
        },
      },
      Artist: {
        x: 0,
        y: 100,
        text: {
          text: 'Loading...',
          textColor: 0xffffffff,
          fontSize: 28,
        },
      },
      visible: false,
    }
  }

  _active() {
    this.patch({
      Header: {
        text: { textColor: this.textColor },
      },
      Title: {
        text: { textColor: this.textColor },
      },
      Artist: {
        text: { textColor: this.textColor },
      },
    })
  }

  updateInfo(data) {
    if (data.type == 'track') {
      this.patch({
        Title: { text: data.title },
        Artist: { text: data.artist },
        visible: true,
      })
    } else {
      this.patch({ visible: false })
    }
  }
}
